module.exports = __webpack_public_path__ + "img/top-right-bg.d80e9cd9.png";